import { useState } from "react";

const navItems = [
  { href: "#latest", label: "最新进展" },
  { href: "#timeline", label: "后续瓜" },
  { href: "#evidence", label: "新证据" },
  { href: "#notices", label: "官方通报" },
  { href: "#topics", label: "追踪专题" },
  { href: "#faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-6">
          <h1 className="shrink-0">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                曝
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                  网曝黑料
                </span>
                <span className="mt-1 text-[11px] tracking-[0.2em] text-foreground-500">
                  追踪 · 通报 · 更新
                </span>
              </span>
            </a>
          </h1>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <span className="flex items-center gap-2 text-xs text-foreground-600">
              <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
              实时更新中
            </span>
            <a
              href="#topics"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即追踪
            </a>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-sm text-foreground-800 last:border-none hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#topics"
              onClick={() => setOpen(false)}
              className="mt-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              立即追踪
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}